import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
// components

import CardLineChart from "components/Cards/CardLineChart.js";
import CardBarChart from "components/Cards/CardBarChart.js";
import ColumnChart from "components/Cards/ColumnChart";
import MonthColumnchart from "components/Cards/MonthColumnchart";
import CardStats from "components/Cards/CardStats";
import HeaderStats from "components/Headers/HeaderStats";
import ExpensesTypewisetable from "components/Cards/ExpensesTypewisetable";
import UserMessageCountsChart from "components/CardsForMarketing/UserMessageCountsChart";
import ExpanseTypeWiseLineChart from "components/Cards/ExpanseTypeWiseLineChart";

export default function Dashboard() {
  const history = useHistory();
  const [years, setYears] = useState([]);

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  //get userid form loca storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  // 🔥 Fetch Years
  useEffect(() => {
    const fetchYears = async () => {
      try {
        const res = await fetch(
          `https://expense-chart-w33t.vercel.app/api/available-years?groupId=${groupId}`
        );
        const data = await res.json();
        setYears(data.years || []);
        console.log("Available Years:", data.years);
      } catch (error) {
        console.error("Error fetching years:", error);
      }
    };

    if (groupId) {
      fetchYears();
    }
  }, [groupId]);

  return (
    <>
      <Navbar />
      {/* <div className="flex flex-wrap mb-3">
        <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
          <HeaderStats/>
        </div>
      </div> */}
      <HeaderStats />

      {/* <div className="flex flex-wrap">
        <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
          <CardLineChart />
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardBarChart />
        </div>
      </div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
          <ColumnChart />
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <MonthColumnchart />
        </div>  
      </div> */}
      {/* <div className="flex flex-wrap mt-3">
        <div className="w-full xl:w-12/12 xl:mb-0 px-3">
          <ExpanseTypeWiseLineChart />
        </div>
      </div> */}
      <div className="flex flex-wrap mt-3">
        <div className="w-full xl:w-12/12 xl:mb-0 px-3">
          <ExpensesTypewisetable years={years} />
        </div>
      </div>
      <div className="flex flex-wrap mt-3">
        <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-3">
          <UserMessageCountsChart />
        </div>
      </div>
      <Footer />
    </>
  );
}
